import { interpolateRecord } from '@/utils/theme/utils';

import { palette as darkPalette } from './dark';
import { palette as lightPalette } from './light';
import { palette } from './palette';
import { palette as pinkPalette } from './pink';

export const lightmodeCssVarDefinitions = interpolateRecord(
  lightPalette,
  '--',
  color => color
);

export const darkmodeCssVarDefinitions = interpolateRecord(
  darkPalette,
  '--',
  color => color
);

export const pinkmodeCssVarDefinitions = interpolateRecord(
  pinkPalette,
  '--',
  color => color
);

export const paletteCssVars = Object.keys(palette).reduce(
  (acc, key) => {
    acc[key as keyof typeof palette] = `var(--${key})`;
    return acc;
  },
  {} as typeof palette
);

export const paletteCssVarsRaw = Object.keys(palette).reduce(
  (acc, key) => {
    acc[key as keyof typeof palette] = `--${key}`;
    return acc;
  },
  {} as typeof palette
);
